import React from "react";
import "./Contact.css";
import HeaderSection from "../../common/HeaderSection/Header";
import donatefour from "../../assets/contact/side-image.jpg"
import Quote from "../../common/Quote/Quote";
import team1 from "../../assets/team1.png";
import team2 from "../../assets/team2.png";
import girls from "../../assets/contact/girls.png";
import girlsimg2 from "../../assets/contact/contactimg1.jpg";
import girlsimg3 from "../../assets/contact/contactimg2.jpg";
import StoriesOfImpact from "../../common/Story/Story";
import Donate from "../../common/Donation/Donate";
import ContactForm from "../../common/ContactForm/Contact"
import DonateToFood from "../../common/DonateToFood/DonateFood"
import DonationForm from "../../common/DonationForm/DonationForm";
import CarouselPage from "../../common/Carousel/CarouselPage";



const ContactPage = () => {
  const carouselImages = [
    { src: girls, alt: "First image ",style: { height: "600px", width: "100%", objectFit: "cover" } },
    { src: girlsimg2, alt: "Second image",style: { height: "600px", width: "100%", objectFit: "cover" } },
    { src: girlsimg3, alt: "Third image" ,style: { height: "600px", width: "100%", objectFit: "cover" }},
  ];
  
  return (
    <div className="banner-container">
      <CarouselPage images={carouselImages} />
    <HeaderSection className= "contact-banner home-image"
    image={girls}
          imageStyle={{marginTop: "3rem"}}
        text="Contact Us"
        longtext=" “ EMPOWERING YOUNG HEARTS CHANGING FUTURES “"
      />
      <h1 className="title" style={{ padding: '0 20px', textAlign: 'center' }}>Donating Poor People.</h1>
      <div className="container">
        <div className="image-section">
          <img src={donatefour} alt="Grid" />
        </div>
        {/* <div className="category-container">
          <h2 className="category-title">Category</h2>
          <ul className="category-list">
            <li>Education <span>(3)</span></li>
            <li>Food <span>(2)</span></li>
            <li>Medical <span>(4)</span></li>
            <li>Home <span>(5)</span></li>
            <li>Water <span>(4)</span></li>
          </ul>
        </div> */}
        <div className="category-container">
  <h2 className="category-title">Category</h2>
  <div className="table-responsive">
    <table className="category-table">
      <thead>
        <tr>
          <th>Category</th>
          <th>Count</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Education</td>
          <td>(3)</td>
        </tr>
        <tr>
          <td>Food</td>
          <td>(2)</td>
        </tr>
        <tr>
          <td>Medical</td>
          <td>(4)</td>
        </tr>
        <tr>
          <td>Home</td>
          <td>(5)</td>
        </tr>
        <tr>
          <td>Water</td>
          <td>(4)</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

      </div>
        <Quote text="“ When you learn, teach. When you get, give ”" />
       <DonateToFood text="Donate to help India’s children & their happiness" image={girls}/>


<DonationForm showHeader={false} />
      
       <div className="team-container">
      <h2 className="team-title">Meet Our Team</h2>
      <div className="team-members">
        <div className="team-member">
        <img src={team2} alt="Nand Kishore Mahato" className="team-photo max-w-full rounded-lg mx-auto "/>
          <div className="team-info">
            <h3 className="team-role">PRESIDENT</h3>
            <h4 className="team-name">NAND KISHORE MAHATO</h4>
            <div className="qualification-box">
              <p className="team-qualifications">
                <strong>EDUCATIONAL QUALIFICATION:</strong> AMIE(I) Mining
                Engineering, MA(Mathematics), B.Ed, Diploma in Software Engg,
                Diploma in French Language.
              </p>
            </div>
            <p className="team-email">Nand.Mahato@etechnoedu.org</p>
          </div>
        </div>
        <div className="team-member">
          <img
            src={team1}
            alt="Jaba Mahato"
            className="team-photo"
          />
          <div className="team-info">
            <h3 className="team-role">TREASURER</h3>
            <h4 className="team-name">JABA MAHATO</h4>
            <p className="team-qualifications qualification-box">
              <strong>EDUCATIONAL QUALIFICATION:</strong> BSc(Chemistry Hons),
              MSc(Chemistry), B.Ed.
            </p>
            <p className="team-email">Jaba.Mahato@etechnoedu.org</p>
          </div>
        </div>
      </div>
      </div>
       <Donate/>
       <StoriesOfImpact/>
       <ContactForm/>
    </div>
  );
};

export default ContactPage;
